import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";

interface OperatorConsoleStatusStripProps {
  selectedSessionId?: string;
}

export function OperatorConsoleStatusStrip({ selectedSessionId }: OperatorConsoleStatusStripProps) {
  return (
    <Card>
      <CardContent className="flex flex-wrap items-center gap-2 pt-4 text-xs">
        <Badge variant="outline">Operator-only surface</Badge>
        <Badge variant="pending">Transport wiring pending</Badge>
        <Badge variant="running">Runtime state model pending</Badge>
        <Badge variant="outline">Thread parity pending</Badge>
        <span style={{ color: "var(--muted-foreground)" }}>
          {selectedSessionId
            ? `Route-selected session: ${selectedSessionId}`
            : "No session selected yet. Route and shell scaffolding are in place."}
        </span>
      </CardContent>
    </Card>
  );
}
